import React, { useCallback, useEffect, useState } from 'react'
import DynamicTable from '../../../../../components/DynamicTable/DynamicTable';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllRoles } from '../../../../../redux/UserReducer/action';
import { Col, Form, Row } from 'react-bootstrap';
import FilledButton from '../../../../../components/Buttons/FilledButton';
import { ROLES_PERMISSIONS_DATA, ROLES_PERMISSIONS_MANAGEMENT } from '../../../../../config/roles_and_permissions';
import { isAuthorised, resetForm } from '../../../../../utils/common';
import PermissionDrawer from '../../../components/PermissionDrawer/PermissionDrawer';
import { toast } from 'react-toastify';
import axios from 'axios';
import '../../RolesPermissionsDashboard/RolesPermissionsDashboard.css';
import CreateModal from '../../../../../components/CreateModal/CreateModal';
import CustomPagination from '../../../../../components/Pagination/CustomPagination';
import useDebounce from '../../../../../hooks/useDebounce';
import { getAuthToken } from "../../../../../utils/auth";

const INITIAL_CREATE_ROLE_STATE = {
    "role_name": "",
    // "parent_role_id": 0,
    "short_name": "",
    // "department": "",
    "department_id": 0,
    // "is_active": true,
    // "created_by": "system",
    // "updated_by": "system"
};

const RolesPermissionsPage = () => {

    const { rolesList, rolesPagination, officerProfile } = useSelector((store) => {
        return {
            rolesList: store.UserReducer.roles.rolesList,
            rolesPagination: store.UserReducer.roles.pagination,
            officerProfile: store.UserReducer.officerProfile,
        }
    }, []);

    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedRole, setSelectedRole] = useState(null);
    const [openCreateRoleModal, setOpenCreateRoleModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    let storedRoleFilters = JSON.parse(sessionStorage.getItem("roleFilters"));
    let [roleFilters, setRoleFilters] = useState({
        role_code: '' || storedRoleFilters?.role_code,
        role_name: '' || storedRoleFilters?.role_name,
        is_active: true || storedRoleFilters?.is_active,
    });

    const [searchText, setSearchText] = useState(storedRoleFilters?.role_name || "");
    const debouncedSearch = useDebounce(searchText, 500);

    let [createRoleForm, setCreateRoleForm] = useState(INITIAL_CREATE_ROLE_STATE);

    useEffect(() => {
        dispatch(getAllRoles(currentPage, limit, roleFilters));

        sessionStorage.setItem("roleFilters", JSON.stringify(roleFilters));
    }, [dispatch, currentPage, limit, roleFilters]);

    // useEffect(() => {
    //     handlePageChange(1);

    //     setRoleFilters((prev) => ({
    //         ...prev,
    //         role_name: debouncedSearch,
    //     }));
    // }, [debouncedSearch, handlePageChange]);

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-type': 'application/json'
    }

    const fetchRolePermissionsByRoleId = async (roleId) => {
        try {
            let resp = await axios.get(
                            `${process.env.REACT_APP_API_BASE_URL}/administration/role-permissions/${roleId}`, 
                            { headers }
                        );

            if(resp?.data?.status){
                return resp?.data?.data; //returns the permissions array
            }
            else {
                return [];
            }

        } catch (error) {
            let errorMsg = error?.response?.data?.message;
            // toast.error(`${errorMsg}`);
            return [];
        }
    }

    const handleAction = async (action, role) => {

        let rolePermissions = await fetchRolePermissionsByRoleId(role?.role_id);

        let updatedRole = {
            ...role,
            permissions: rolePermissions
        }

        if (action === 'manage-permissions') {
            setSelectedRole(updatedRole);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log({ name, value });

        let finalValue;

        if (name === "is_active") {
            finalValue = value === "" ? "" : value === "true";
        }
        else {
            finalValue = value;
        }
    }

     const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };

    const handleRoleCreation = async (newRole) => {

        try {
            let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/masters/create-role`, newRole, { headers });

            // if(response?.data?.status){
                toast.success(`Role created successfully.`);

                resetForm(setCreateRoleForm(INITIAL_CREATE_ROLE_STATE));
                setOpenCreateRoleModal(false);
                dispatch(getAllRoles(currentPage, limit, roleFilters));
            // }
            // else{
            //     toast.error(`${response?.data?.message}`);
            // }
        }
        catch (error) {
            let errorMsg = error?.response?.data?.message;
            // toast.error(`${errorMsg}`);
        }
    }

    return (
        <div>
            <div>
                <div className="user-filters">
                    <Row className="g-2 align-items-center">

                        {/* Search */}
                        <Col md={6}>
                            <Form.Control
                                name='role_name'
                                type="text"
                                placeholder="Search by role name"
                                // value={searchText}
                                // onChange={(e) => setSearchText(e.target.value)}
                                value={roleFilters?.role_name}
                                onChange={(e) => {
                                    handlePageChange(1);

                                    setRoleFilters((prev) => ({
                                        ...prev,
                                        role_name: e.target.value,
                                    }));
                                }}
                            />
                        </Col>


                        <Col md="auto" className="ms-auto">
                            {
                                // isAuthorised(officerProfile, ROLES_PERMISSIONS_MANAGEMENT.create_role.permissions) && 
                                <FilledButton 
                                    title={ROLES_PERMISSIONS_MANAGEMENT.create_role.title}
                                    handleClick={() => {
                                        setOpenCreateRoleModal(true);
                                    }}
                                />
                            }
                        </Col>

                    </Row>
                </div>

                <div className='dynamic-table-container'>
                    <DynamicTable
                        columns={ROLES_PERMISSIONS_DATA}
                        data={rolesList}
                        onAction={handleAction}
                    />
                </div>

                 {
                    rolesList?.length > 0 &&
                    <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                }
            </div>

            <PermissionDrawer
                role={selectedRole}
                onClose={() => setSelectedRole(null)}
                roleFilters={roleFilters}
                currentPage={currentPage}
                limit={limit}
            />

            {
                openCreateRoleModal &&
                <CreateModal 
                    config={ROLES_PERMISSIONS_MANAGEMENT.create_role}
                    obj={createRoleForm}
                    setObj={setCreateRoleForm}
                    onClose={() => {
                        setOpenCreateRoleModal(false);
                        resetForm(setCreateRoleForm, INITIAL_CREATE_ROLE_STATE);
                    }}
                    handleSubmit={() => {
                        handleRoleCreation(createRoleForm);
                    }}
                />
            }
        </div>
    )
}

export default RolesPermissionsPage